import { Component, input, InputSignal } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'aw-toggle-chip',
  standalone: true,
  templateUrl: './toggle-chip.component.html',
  imports: [NgClass],
})
export class ToggleChipComponent {
  public readonly isChecked: InputSignal<boolean> = input.required<boolean>();
  public readonly text: InputSignal<string> = input.required<string>();
}
